/* import __COLOCATED_TEMPLATE__ from './expired.hbs'; */
import { service } from '@ember/service';
import Component from '@glimmer/component';
import styles from './paid-or-expired.module.scss';

export default class PaymentLinkExpired extends Component {
  styles = styles;

  @service('session') clientPortalSession;
  @service currentPractice;

  get isClientPortalAuthenticated() {
    return this.clientPortalSession.isAuthenticated;
  }

  get isPaymentLinkSmsEnabled() {
    return this.currentPractice.get('featurePaymentLinksSms');
  }
}
